#@import _
#@import moment
#@import Booking.Helpers
#@import Booking.Models.Base
#@export Booking.Models.PossibleSegment

class Booking.Models.PossibleSegment extends Booking.Models.Base

  idAttribute: 'start_datetime'

  constructor: ->
    Booking.Models.Base.apply this, arguments

  getTimezone: ->
    @collection.getTimezone()

  start: ->
    # TODO - Change to always do this the same way (either passing in a moment object or a timestamp).
    Booking.Helpers.objectInTimezone @get('start_datetime'), @getTimezone()

  end: ->
    # TODO - Change to always do this the same way (either passing in a moment object or a timestamp).
    Booking.Helpers.objectInTimezone @get('end_datetime'), @getTimezone()

  id: ->
    @get('id')

  getSegmentId: ->
    @get('segment_id')

Booking.Models.PossibleSegment::createFromTimeModel = (model) ->
  segment = {}
  segment['start_datetime'] = model.start()
  segment['end_datetime'] = model.end()
  segment['segment_id'] = model.get('id')

  # create a new PossibleSegment Model
  new Booking.Models.PossibleSegment(segment)
